import React, { Component } from "react";

export class User extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            userIsAuthorized: false,
            data: {}
        }
    }

    componentDidMount() {
        let idUser = parseInt(window.location.href.substring(window.location.href.lastIndexOf('/')+1, window.location.href.length));
        this.getUser(idUser === isNaN ? 0 : idUser);
    }

    static renderOption(context) {
        if (context.state.userIsAuthorized) {
            return context.renderPage(context);
        }
        return context.noAuthorized(context);
    }

    renderPage(context) {
        return (
            <div id="tab1" className="tab-pane fade in active show">
                <div className="group-form col-lg-12 wrapp-image">
                    <img src={this.state.data ? this.state.data.userImage : null} />
                </div>
                <div className="group-form col-lg-6">
                    <label>* Correo electrónico</label>
                    <input readOnly="true" defaultValue={this.state.data ? this.state.data.email : null} type="email" name="email" className="form-control" required maxLength="100" />
                </div>
                <div className="group-form col-lg-6">
                    <label>* Nombre completo</label>
                    <input readOnly="true" defaultValue={this.state.data ? this.state.data.name : null} type="text" name="name" className="form-control" required maxLength="50" />
                </div>
                <div className="group-form col-lg-6">
                    <label>* Edad</label>
                    <input readOnly="true" defaultValue={this.state.data ? this.state.data.age : null} type="number" name="age" className="form-control" required maxLength="3" />
                </div>
                <div className="group-form col-lg-6">
                    <label>* Cédula de ciudadania</label>
                    <input readOnly="true" defaultValue={this.state.data ? this.state.data.identification : null} type="number" name="identification" className="form-control" required maxLength="10" />
                </div>
                <div className="group-form col-lg-6">
                    <label>* Ciudad de residencia</label>
                    <input readOnly="true" defaultValue={this.state.data ? this.state.data.city : null} type="text" name="city" className="form-control" required maxLength="50" />
                </div>
                <div className="group-form col-lg-6">
                    <label>* Dirección de residencia</label>
                    <input readOnly="true" defaultValue={this.state.data ? this.state.data.address : null} type="text" name="address" className="form-control" required maxLength="100" />
                </div>
                <div className="group-form col-lg-6">
                    <label>* ¿En qué número de teléfono podemos ponernos en contacto contigo?</label>
                    <input readOnly="true" defaultValue={this.state.data ? this.state.data.contact : null} type="number" name="contact" className="form-control" required maxLength="15" />
                </div>
                <div className="group-form col-lg-6">
                    <label>* Ahora queremos saber quién te invito a vivir este entrenamiento, ¿cuál es su nombre y apellido?</label>
                    <input readOnly="true" defaultValue={this.state.data ? this.state.data.enroller : null} type="text" name="enroller" className="form-control" required maxLength="100" />
                </div>
                <div className="group-form col-lg-6">
                    <label>* ¿cuál es el número de contacto de la persona que te invitó?</label>
                    <input readOnly="true" defaultValue={this.state.data ? this.state.data.enrollerNumber : null} type="number" name="enrollerNumber" className="form-control" required maxLength="100" />
                </div>
                <div className="group-form col-lg-6">
                    <label>* EN CASO DE EMERGENCIA: ¿con quién quieres que nos comuniquemos?, ¿Cuál es su nombre?</label>
                    <input readOnly="true" defaultValue={this.state.data ? this.state.data.emergencyName : null} type="text" name="emergencyName" className="form-control" required maxLength="100" />
                </div>
                <div className="group-form col-lg-6">
                    <label>* EN CASO DE EMERGENCIA: ¿Cuál es el número de tu contacto? </label>
                    <input readOnly="true" defaultValue={this.state.data ? this.state.data.emergencyNumber : null} type="text" name="emergencyNumber" className="form-control" required maxLength="15" />
                </div>
                <div className="group-form col-lg-6">
                    <a target="_blank" href={`/usuarios-registrados/email/${this.state.data ? this.state.data.email : ''}`}>Ver en la consola del administrador</a>
                </div>
            </div>
        )
    }

    noAuthorized(context) {
        return (
            <div>
                <h4>Usuario no autorizado para ver esta página.</h4>
            </div>
        )
    }

    async getUser(idUser) {

        const request = {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `bearer ${localStorage.getItem('token')}`
            }
        }

        this.setState({ loading: true });
        let response = await fetch(`Register/GetById?id=${idUser}`, request);
        if (response.redirected) {
            window.location.href = response.url;
        }
        let data = await response.json();
        this.setState({ loading: false, data: data, userIsAuthorized: true });
    }

    render() {

        let content = this.state.loading ? <h2>Cargando</h2> : User.renderOption(this);

        return (
            <div>
                {content}
            </div>
        )
    }
}